import { render, staticRenderFns } from "./clueChange.vue?vue&type=template&id=3dff3200&scoped=true"
import script from "./clueChange.vue?vue&type=script&lang=js"
export * from "./clueChange.vue?vue&type=script&lang=js"
import style0 from "./clueChange.vue?vue&type=style&index=0&id=3dff3200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff3200",
  null
  
)

export default component.exports